import React from "react";
import ShadowsBackground from "./ShadowsBackground";

import { AnimatePresence } from "framer-motion";
import Helmetor from "../_utils/Helmetor";
import rootcolors from "../_utils/rootColors";

const SeasonOverlay = ({ data, overlay }) => {
  const { colorVar } = overlay;
  const themeColor = colorVar ? colorVar.replace(/-|w|color/g, "") : data.alias;
  const overlayfilter =
    rootcolors[`${data.alias}overlayfilter`] ??
    `blur(2px) grayscale(1) brightness(.67)`;
  const overlayfiltercolor =
    rootcolors[`${data.alias}overlayfiltercolor`] ?? `#fff0`;

  // console.log(themeColor);

  // init transparent
  // episodes
  // console.log("hallo image url? ", imgUrl);
  return (
    <>
      <Helmetor colorVar={colorVar} />
      <div
        className="position-absolute vh-100 vw-100 d-flex justify-content-center"
        style={{ overflow: "hidden" }}>
        <div
          style={{
            backgroundColor: colorVar ? overlayfiltercolor : `#fff0`,
            backdropFilter: colorVar ? overlayfilter : `blur(0)`,
            transition: "filter .8s, background-color .8s",
            // mixBlendMode: "luminosity",
            // backgroundBlendMode: "luminosity",
          }}
          className="vw-100 vh-100"></div>
        <AnimatePresence exitBeforeEnter>
          <div
            key={"backgroundShadows" + themeColor}
            className="season-overlay-frame"
            style={{
              mixBlendMode: "multiply",
              backgroundBlendMode: "multiply",
            }}>
            <ShadowsBackground overlay={overlay} />
          </div>
        </AnimatePresence>
        {/* {colorVar && (
          <div
            className="season-overlay-frame vw-100 vh-100"
            style={{
              backgroundImage: `url('${process.env.REACT_APP_BASE_URL}/assets/app/img/bg-grey.png')`,
              backgroundRepeat: "repeat",
              mixBlendMode: "multiply",
              backgroundBlendMode: "multiply",
            }}
          />
        )} */}

        <div
          className="season-overlay-frame vw-100 vh-100"
          style={{
            backgroundColor: colorVar ? `var(${colorVar})` : `#fff0`,
            mixBlendMode: "color",
            backgroundBlendMode: "color",
            //transition: "1s background-color",
          }}></div>
      </div>
    </>
  );
};

export default SeasonOverlay;
